export const sectionsActionTypes = {
  SET_HOVERED_SECTION_LIKE_REF: '@sections/SET_HOVERED_SECTION_LIKE_REF',
  SHOW_SECTIONIZED_PANEL: '@sections/SHOW_SECTIONIZED_PANEL',
  HIDE_SECTIONIZED_PANEL: '@sections/HIDE_SECTIONIZED_PANEL',
  SET_SECTION_ACTION_BAR_HOVERED: '@sections/SET_SECTION_ACTION_BAR_HOVERED',
} as const;

export type SectionsActionTypes = ValueOf<typeof sectionsActionTypes>;
